<template>
  <footer class="page-footer">
    <div class="container">
      <div class="row">
        <ul>
          <li v-for="item in menuItems" :key="item.path">
            <router-link :to="item.routeName ? { name: item.routeName } : item.path">
              {{ item.label }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-copyright">
      <div class="container">
        <div class="row">
          <div class="col s12 m6">
            <p>Copyright © 2025. All rights reserved</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { routes } from '@/router';

export default {
  name: 'FooterSection',
  computed: {
    menuItems() {
      const routerOptions = this.$router && this.$router.options && Array.isArray(this.$router.options.routes) ? this.$router.options.routes : null;
      const imported = Array.isArray(routes) && routes.length ? routes : null;
      let source = routerOptions || imported;

      if (!source && this.$router && typeof this.$router.getRoutes === 'function') {
        const flat = this.$router.getRoutes() || [];
        // tomar rutas de primer nivel
        source = flat.filter(r => {
          if (!r.path) return false;
          if (r.path.includes('*')) return false;
          const segs = r.path.split('/').filter(Boolean);
          return segs.length <= 1;
        });
      }

      if (!Array.isArray(source) || !source.length) return [];

      return source
        .filter(r => r.meta?.hideFromFooterMenu !== true)
        .map(r => ({
          label: r.meta?.title || r.name || r.path,
          routeName: r.name || null,
          path: r.path,
        }));
    },
  },
};
</script>
